import * as React from "react";
import { Typography } from "@mui/material";
import { FormattedMessage } from "react-intl";
import { FieldErrorList } from "../types";

type ContextData = { [s: string]: any };

export const ErrorText = ({ data }: { data: FieldErrorList }) => {
    if (data.length === 0) return null;

    return (
        <React.Fragment>
            {data.map((item, index) => (
                <Typography key={index} variant="caption" display="block" color="error">
                    {/* eslint-disable-next-line formatjs/enforce-id */}
                    <FormattedMessage id={item.data.key} values={item.data as ContextData} />
                </Typography>
            ))}
        </React.Fragment>
    );
};
